var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconContactCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5197",
    "data-name": "Group 5197",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35.281,
    height: 28.253,
    viewBox: "0 0 35.281 28.253",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1809",
    "data-name": "Rectangle 1809",
    width: 35.281,
    height: 28.253,
    fill: "rgba(248,225,247,0.5)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5196",
    "data-name": "Group 5196",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14019",
    "data-name": "Path 14019",
    d: "M12.1,0H23.182a7.1,7.1,0,0,1,1.074.4A2.657,2.657,0,0,1,25.6,2.666h.461c1.516,0,3.033-.007,4.549.005a5.756,5.756,0,0,1,1.19.111,4.36,4.36,0,0,1,3.477,4.466q.009,8.2,0,16.408a5.184,5.184,0,0,1-.059.905,4.419,4.419,0,0,1-4.593,3.691q-12.985,0-25.971,0a5.534,5.534,0,0,1-1.15-.1,4.3,4.3,0,0,1-3.49-4.2C-.013,18.283.005,12.621.008,6.959a3.43,3.43,0,0,1,.053-.616A4.407,4.407,0,0,1,4.544,2.668c1.558-.011,3.115,0,4.673,0h.437a2.791,2.791,0,0,1,1.4-2.292A7.889,7.889,0,0,1,12.1,0M9.667,4.444c-1.719,0-3.413,0-5.107,0a2.634,2.634,0,0,0-2.8,2.831q0,8.184,0,16.367a2.632,2.632,0,0,0,2.8,2.83q13.069.005,26.137,0a2.637,2.637,0,0,0,2.822-2.812q0-8.2,0-16.409a2.631,2.631,0,0,0-2.784-2.808c-1.585-.007-3.171,0-4.756,0-.121,0-.243.011-.358.017-.384,1.923-1.248,2.628-3.2,2.628H12.706A2.732,2.732,0,0,1,9.667,4.444M17.683,1.8c-1.722,0-3.445,0-5.167,0-.739,0-1.05.318-1.058,1.061,0,.482-.008.964,0,1.446a.888.888,0,0,0,.991,1q5.188.007,10.376,0a.891.891,0,0,0,1-1c.01-.468,0-.936,0-1.4,0-.8-.3-1.106-1.1-1.107q-2.522,0-5.043,0",
    transform: "translate(0)",
    fill: "rgba(248,225,247,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14020",
    "data-name": "Path 14020",
    d: "M77.132,125.258a3.911,3.911,0,1,1,3.906-3.928,3.925,3.925,0,0,1-3.906,3.928m-.007-1.763a2.152,2.152,0,1,0-2.161-2.141,2.154,2.154,0,0,0,2.161,2.141",
    transform: "translate(-67.123 -107.7)",
    fill: "rgba(248,225,247,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14021",
    "data-name": "Path 14021",
    d: "M64.3,225.308H62.543a3.918,3.918,0,0,0-1.574-3.046,3.738,3.738,0,0,0-2.4-.75q-2.983.087-3.735,3.787H53.11a5.4,5.4,0,0,1,2.347-4.5,5.33,5.33,0,0,1,6-.308,5.454,5.454,0,0,1,2.84,4.818",
    transform: "translate(-48.707 -201.494)",
    fill: "rgba(248,225,247,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14022",
    "data-name": "Path 14022",
    d: "M229.247,127.853c1.557,0,3.114,0,4.671,0,.58,0,.949.251,1.04.686a.864.864,0,0,1-.681,1.055,1.523,1.523,0,0,1-.327.033q-4.691,0-9.383,0c-.591,0-.964-.282-1.028-.748-.082-.6.316-1.021,1-1.025,1.309-.009,2.618,0,3.927,0h.785",
    transform: "translate(-204.995 -117.25)",
    fill: "rgba(248,225,247,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14023",
    "data-name": "Path 14023",
    d: "M229.21,193.463c-1.543,0-3.086,0-4.629,0-.6,0-.969-.273-1.04-.735a.86.86,0,0,1,.695-1.009,1.8,1.8,0,0,1,.369-.031q4.65,0,9.3,0c.623,0,1,.276,1.063.755.077.6-.322,1.014-1,1.019-1.392.008-2.783,0-4.175,0h-.579",
    transform: "translate(-204.995 -175.792)",
    fill: "rgba(248,225,247,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14024",
    "data-name": "Path 14024",
    d: "M229.251,257.276c-1.557,0-3.114,0-4.671,0-.6,0-.969-.274-1.038-.737a.86.86,0,0,1,.7-1.007,1.816,1.816,0,0,1,.369-.031q4.65,0,9.3,0c.622,0,1,.277,1.061.757.076.6-.323,1.013-1.006,1.017-1.433.008-2.866,0-4.3,0h-.413",
    transform: "translate(-204.996 -234.315)",
    fill: "rgba(248,225,247,0.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContactCard);
export default __webpack_public_path__ + "static/media/icon-contact-card.22a227e0dae36f76d74dd516ac93e16f.svg";
export { ForwardRef as ReactComponent };